export var primaryMainColor = function (_a) {
    var theme = _a.theme;
    return theme.velocity.styling.primary.main;
};
export var primaryDarkColor = function (_a) {
    var theme = _a.theme;
    return theme.velocity.styling.primary.dark;
};
export var secondaryMainColor = function (_a) {
    var theme = _a.theme;
    return theme.velocity.styling.secondary.main.default;
};
export var secondaryMain20Color = function (_a) {
    var theme = _a.theme;
    return theme.velocity.styling.secondary.main['20'];
};
export var secondaryMain80Color = function (_a) {
    var theme = _a.theme;
    return theme.velocity.styling.secondary.main['80'];
};
export var secondaryDarkColor = function (_a) {
    var theme = _a.theme;
    return theme.velocity.styling.secondary.dark.default;
};
export var secondaryDark80Color = function (_a) {
    var theme = _a.theme;
    return theme.velocity.styling.secondary.dark['80'];
};
export var systemErrorMainColor = function (_a) {
    var theme = _a.theme;
    return theme.velocity.styling.system.error.main;
};
export var systemErrorLightColor = function (_a) {
    var theme = _a.theme;
    return theme.velocity.styling.system.error.light;
};
export var systemWarningMainColor = function (_a) {
    var theme = _a.theme;
    return theme.velocity.styling.system.warning.main;
};
export var systemWarningLightColor = function (_a) {
    var theme = _a.theme;
    return theme.velocity.styling.system.warning.light;
};
export var systemSuccessMainColor = function (_a) {
    var theme = _a.theme;
    return theme.velocity.styling.system.success.main;
};
export var systemSuccessLightColor = function (_a) {
    var theme = _a.theme;
    return theme.velocity.styling.system.success.light;
};
export var interfaceBackgroundMainColor = function (_a) {
    var theme = _a.theme;
    return theme.velocity.styling.interface.background.main;
};
export var interfaceBackgroundLightColor = function (_a) {
    var theme = _a.theme;
    return theme.velocity.styling.interface.background.light;
};
export var interfaceBackgroundDarkColor = function (_a) {
    var theme = _a.theme;
    return theme.velocity.styling.interface.background.dark;
};
export var headlineColor = function (_a) {
    var theme = _a.theme;
    return theme.velocity.styling.interface.text.dark;
};
export var textColor = function (_a) {
    var theme = _a.theme;
    return theme.velocity.styling.interface.text.main;
};
export var gray20Color = function (_a) {
    var theme = _a.theme;
    return theme.velocity.styling.gray['20'];
};
export var gray40Color = function (_a) {
    var theme = _a.theme;
    return theme.velocity.styling.gray['40'];
};
export var gray60Color = function (_a) {
    var theme = _a.theme;
    return theme.velocity.styling.gray['60'];
};
export var gray80Color = function (_a) {
    var theme = _a.theme;
    return theme.velocity.styling.gray['80'];
};
export var grayLightColor = function (_a) {
    var theme = _a.theme;
    return theme.velocity.styling.gray.light;
};
export var grayMainColor = function (_a) {
    var theme = _a.theme;
    return theme.velocity.styling.gray.main;
};
export var grayDarkColor = function (_a) {
    var theme = _a.theme;
    return theme.velocity.styling.gray.dark;
};
export var formTextDefaultColor = function (_a) {
    var theme = _a.theme;
    return theme.velocity.styling.forms.text.default;
};
export var formTextPlaceholderColor = function (_a) {
    var theme = _a.theme;
    return theme.velocity.styling.forms.text.placeholder;
};
export var formTextDisabledColor = function (_a) {
    var theme = _a.theme;
    return theme.velocity.styling.forms.text.disabled;
};
export var formBgDefaultColor = function (_a) {
    var theme = _a.theme;
    return theme.velocity.styling.forms.background.default;
};
export var formBgDisabledColor = function (_a) {
    var theme = _a.theme;
    return theme.velocity.styling.forms.background.disabled;
};
export var formBorderColor = function (_a) {
    var theme = _a.theme;
    return theme.velocity.styling.forms.border.default;
};
export var formFocusBorderColor = function (_a) {
    var theme = _a.theme;
    return theme.velocity.styling.forms.border.focus;
};
export var formHoverBorderColor = function (_a) {
    var theme = _a.theme;
    return theme.velocity.styling.forms.border.hover;
};
export var formCheckColor = function (_a) {
    var theme = _a.theme;
    return theme.velocity.styling.forms.check.default;
};
export var formCheckFocusColor = function (_a) {
    var theme = _a.theme;
    return theme.velocity.styling.forms.check.focus;
};
export var interfaceTextContrastColor = function (_a) {
    var theme = _a.theme;
    return theme.velocity.styling.interface.text.contrast;
};
export var interfaceTextLightColor = function (_a) {
    var theme = _a.theme;
    return theme.velocity.styling.interface.text.light;
};
export var iconPrimaryMainColor = function (_a) {
    var theme = _a.theme;
    return theme.velocity.styling.icons.primary.main;
};
//# sourceMappingURL=color-mixins.js.map